<div class="h-full flex flex-col flex-1 patternBG">

  <app-header-client [opened]=opened (toggleMenu)="leftNav.toggle()"></app-header-client>

  <div class="flex flex-row flex-1">

    <!-- Side menu  -->
    <mat-sidenav-container fxFlex *ngIf="!loader">

      <!-- [disableClose]="true" -->
      <mat-sidenav class="flex flex-col flex-1" #leftNav [opened]="opened" [mode]="mode">

        <div class="flex flex-col flex-1 p-4">

          <!-- Header -->
          <div class="flex flex-col mb-4 p-2">
            <h2 class="text-lg text-gray-800">{{clientAccount$.firstname}} {{clientAccount$.lastname}}</h2>
            <p class="text-sm text-gray-500">{{clientAccount$.mail}}</p>
          </div>

          <!-- Items  -->
          <div class="flex-1">
            <ul class="flex flex-col">

              <!-- Merchants -->
              <li
                [ngClass]="cssService.itemListSidenav"
                (click)="changePage('dashboard')"
                [class.bg-indigo-100]="currPage === 'dashboard'"
              >
                <i class="fas fa-store text-gray-600"></i>
                <span
                  class="uppercase text-sm font-medium text-gray-800">{{ 'client.menu.merchants' | translate }}</span>
              </li>

              <!-- Cards
              <li
                [ngClass]="cssService.itemListSidenav"
                (click)="changePage('cards')"
                [class.bg-indigo-100]="currPage === 'cards'"
              >
                <i class="fas fa-credit-card text-gray-600"></i>
                <span class="uppercase text-sm font-medium text-gray-800">{{ 'client.menu.cards' | translate }}</span>
              </li>-->

              <!-- Orders -->
              <li
                *ngIf="clientMerchantsOptions$ && checkOptions(14)"
                [ngClass]="cssService.itemListSidenav"
                (click)="changePage('orders')"
                [class.bg-indigo-100]="currPage === 'orders'"
              >
                <i class="fas fa-calendar-alt"
                   [ngClass]="cssService.itemListSidenavIcon"></i>
                <span class="uppercase text-sm font-medium text-gray-800">{{ 'client.menu.orders' | translate }}</span>
              </li>

              <!-- Notes
              <li
                *ngIf="clientMerchantsOptions$"
                [ngClass]="cssService.itemListSidenav"
                (click)="changePage('notes')"
                [class.bg-indigo-100]="currPage === 'notes'">
                <i class="fas fa-receipt" [ngClass]="cssService.itemListSidenavIcon"></i>
                <span class="uppercase text-sm font-medium text-gray-800">{{ 'client.menu.notes' | translate }}</span>
              </li>-->

              <!-- Credits
              <li
                *ngIf="clientMerchantsOptions$"
                [ngClass]="cssService.itemListSidenav"
                (click)="changePage('credits')"
                [class.bg-indigo-100]="currPage === 'credits'"
              >
                <i class="fas fa-file-invoice-dollar" [ngClass]="cssService.itemListSidenavIcon"></i>
                <span class="uppercase text-sm font-medium text-gray-800">{{ 'client.menu.credits' | translate }}</span>
              </li>-->

              <!-- Account -->
              <li
                [ngClass]="cssService.itemListSidenav"
                (click)="changePage('account')"
                [class.bg-indigo-100]="currPage === 'account'">
                <i class="fas fa-user" [ngClass]="cssService.itemListSidenavIcon"></i>
                <span class="uppercase text-sm font-medium text-gray-800">{{ 'client.menu.account' | translate }}</span>
              </li>

            </ul>
          </div>

          <!-- Version  -->
          <div class="p-4 flex flex-row">
            <app-version></app-version>
          </div>

        </div>

      </mat-sidenav>

      <!-- Content -->
      <mat-sidenav-content>

        <!-- Pages -->
        <router-outlet></router-outlet>

      </mat-sidenav-content>

      <!-- Side data -->
      <mat-sidenav fxLayout="column" class="side-nav-right" style="width: 450px;" [ngStyle.xs]="{'width' : '100%'}"
                   position="end" mode="over" #rightNav>

        <app-side-data-order *ngIf="sideDataType === 'order'" [order]="sideData"
                             (closeSideEvent)="closeSideData($event)">
        </app-side-data-order>

      </mat-sidenav>

    </mat-sidenav-container>

    <app-popup-loader [flagLoading]="loader" [statusMessage]="'loadPagemain'|translate" [size]="30">
    </app-popup-loader>

  </div>
</div>
